import styles from "./social-media-button.module.scss";
import Image from "next/image";
import Link from "next/link";
import useHover from "@/hooks/use-hover";
import { useClipboard } from "@/hooks/use-clipboard";
import { useMobile } from "@/hooks/use-responsive";

interface SocialMediaButtonProps {
  title: string;
  icon: string;
  hoverIcon: string;
  socialMediaUrl: string;
}

const SocialMediaButton = ({
  title,
  icon,
  hoverIcon,
  socialMediaUrl,
}: SocialMediaButtonProps) => {
  const { isMobile } = useMobile();
  const { isHovering, onMouseLeave, onMouseEnter } = useHover();
  const { copyToClipboard } = useClipboard();

  const handleButtonClick = async () => {
    // temp for test in prod https
    if (isMobile) {
      const shareData = {
        title: "AudioModify",
        text: "AudioModify | AI Music Tools",
        url: "https://app.audiomodify.com/",
      };
      if (navigator.canShare(shareData)) {
        await navigator.share(shareData);
      }
    } else {
      await copyToClipboard(socialMediaUrl);
    }
  };

  return (
    <button
      className={styles.button_wrapper}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={handleButtonClick}
    >
      <div className={styles.image_wrapper}>
        <Image
          src={isHovering ? hoverIcon : icon}
          alt={title}
          width={60}
          height={60}
        />
      </div>
      <div className={styles.social_title}>{title}</div>
    </button>
  );
};

export default SocialMediaButton;
